import { cn } from "$/lib/utils/functions/misc.functions";
import { forwardRef, type ComponentProps } from "react";

export const CustomPhoneInputContainer = forwardRef<
  HTMLDivElement,
  ComponentProps<"div">
>((props, ref) => (
  <div
    {...props}
    ref={ref}
    className={cn(
      props.className,
      "flex flex-row gap-2 rounded-lg border border-[#CED4DA] px-4 py-2.5 text-black",
    )}
  />
));
